import { useEffect } from "react"
import { useGetConfigQuery } from "../app/apiSlice"
import { setConfig } from "../app/appSlice"
import { useAppDispatch } from "./hooks"

const useConfigStore = () => {
    const {data : config} = useGetConfigQuery()
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (config) {
            dispatch(
                setConfig({
                    environnements:config.environnements ? config.environnements : [],
                    sasWarningMessage: config.sasWarningMessage ? config.sasWarningMessage : "",
                    runtimeMode: config.runtimeMode ? config.runtimeMode : [],
                    defaultsKubernetesValues: config.defaultsKubernetesValues,
                    metricList: config.metricList ?? [],
                    cds: config.cds,
                    realm: config.realm,
                    platformLevel: config.platformLevel,
                    onlyMyUdf: config.onlyMyUdf,
                    portailUrl: config.portailUrl ?? "",
                    lastVersionName: config.lastVersionName,
                    datapipelineUiImage: config.datapipelineUiImage ?? "",
                    treatmentVersion: config.treatmentVersion ?? ""
                })
            )
        }
    }, [config])

    return {
       config
    }
}

export default useConfigStore